import { render, staticRenderFns } from "./SpecialtyAndTeams.vue?vue&type=template&id=8a1603fa&scoped=true"
import script from "./SpecialtyAndTeams.vue?vue&type=script&lang=js"
export * from "./SpecialtyAndTeams.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyAndTeams.vue?vue&type=style&index=0&id=8a1603fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1603fa",
  null
  
)

export default component.exports